var scope_0 = require('/home/runner/work/dev-site/dev-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5d4416af62e0c99fd8fa87474086c550.js').default;
var scope_1 = require('/home/runner/work/dev-site/dev-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    